import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/api';

export default function AdminPolicies() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.policies().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-5">
        <h2 className="text-xl font-bold text-[#0b1f3a]">Policies</h2>
        <p className="text-slate-500 text-sm mt-1">All active and inactive policies.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {loading ? (
          <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
        ) : items.length === 0 ? (
          <p className="p-8 text-center text-slate-500 text-sm">No policies yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Type</th>
                <th className="text-left px-4 py-3 font-semibold">Insurer</th>
                <th className="text-left px-4 py-3 font-semibold">Premium</th>
                <th className="text-left px-4 py-3 font-semibold">Renewal</th>
                <th className="text-left px-4 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((p) => (
                <tr key={p.id} className="hover:bg-slate-50/50">
                  <td className="px-4 py-3 text-slate-700 font-medium capitalize">{p.type}</td>
                  <td className="px-4 py-3 text-slate-600">{p.insurer}</td>
                  <td className="px-4 py-3 text-slate-700 font-semibold">€{p.premium}</td>
                  <td className="px-4 py-3 text-slate-600">{p.renewal_date || '—'}</td>
                  <td className="px-4 py-3"><span className={`text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full ${
                    p.status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'
                  }`}>{p.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
